import React from "react";

const TableTop = () => {
    return <div />;
};

export default TableTop;
